<template>
  <el-dialog
    :title="rateCard.name"
    visible
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <h1>
      CSV Export<br>
      <small>
        Export a Rate Card to a Microsoft Excel compatible format
      </small>
    </h1>
    <el-row>
      <el-col>
        <p>Zones</p>
        <el-select
          v-model="selectedZones"
          multiple
          filterable
          placeholder="All Zones"
          :loading="isLoadingZones"
          class="w-100"
          size="small"
        >
          <el-option
            v-for="zone in zones"
            :key="zone.id"
            :label="zone.zone.desc"
            :value="zone.zone.id"
          />
        </el-select>
      </el-col>
    </el-row>
    <br>
    <el-row>
      <el-col>
        <p>Services</p>
        <el-select
          v-model="selectedServices"
          multiple
          filterable
          placeholder="All Services"
          :loading="isLoadingServices"
          class="w-100"
          size="small"
        >
          <el-option
            v-for="service in services"
            :key="service.id"
            :label="service.name"
            :value="service.id"
          />
        </el-select>
      </el-col>
    </el-row>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="exportCSV"
      >
        Export
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    rateCard: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false,
      isSaving: false,
      zones: [],
      isLoadingZones: false,
      services: [],
      isLoadingServices: false,
      selectedZones: [],
      selectedServices: []
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Zones
      this.isLoadingZones = true
      this.$sdk.locationcarrierzone.list(builder => {
        builder.context = { resource: 'pivot' }
        builder.include = ['carrier', 'zone']
        builder.filters = { pivot_location_carrier_zone_carrier: this.rateCard.carrier.id, pivot_location_carrier_zone_grouped: true }
        builder.limit = 1000
      })
        .then(res => { this.zones = res })
        .finally(() => { this.isLoadingZones = false })
      // Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.rateCard.carrier.id }
      }).then(res => { this.services = res })
        .finally(() => { this.isLoadingServices = false })
    },
    exportCSV () {
      this.isSaving = true
      const job = new this.$sdk.job()
      job.name = 'export.csv.ratecard'
      job.parameters = {
        rate_card: this.rateCard.id,
        params: {
          zone_from: this.selectedZones,
          required_services: this.selectedServices
        }
      }
      job.create()
        .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>

<style>

</style>
